// Angular imports
import { HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';

// Data imports
import { CacheEntry } from '../../_models/cache-entry';

@Injectable()
export class RPCacheRegistrationService {
  private _cachedData = new Map<string, CacheEntry>();
  private readonly _services = [];

  public registerForCache(serviceUri: string, clearCache = false) {
    const serviceUrl = this.getServiceUrlWithoutCacheParam(serviceUri);
    if (this._services.indexOf(serviceUrl) === -1) {
      this._services.push(serviceUrl);
    }
    if (clearCache === true) {
      this.deleteCache(serviceUrl);
    }
  }

  public isNeedToCache(serviceUri: string) {
    const serviceUrl = this.getServiceUrlWithoutCacheParam(serviceUri);
    return this._services.indexOf(serviceUrl) > -1;
  }

  public isAddedToCache(serviceUri: string) {
    const serviceUrl = this.getServiceUrlWithoutCacheParam(serviceUri);
    return this._cachedData.has(serviceUrl);
  }

  public addToCache(serviceUri: string, entry: CacheEntry) {
    // Check if not already added to list
    if (!this.isAddedToCache(serviceUri)) {
      const serviceUrl = this.getServiceUrlWithoutCacheParam(serviceUri);
      this._cachedData.set(serviceUrl, entry);
    }
  }

  public getCacheEntry(serviceUri: string) {
    if (this.isAddedToCache(serviceUri)) {
      const serviceUrl = this.getServiceUrlWithoutCacheParam(serviceUri);
      return this._cachedData.get(serviceUrl);
    }
    return null;
  }

  public deleteCache(serviceUri: string) {
    if (this.isAddedToCache(serviceUri)) {
      const serviceUrl = this.getServiceUrlWithoutCacheParam(serviceUri);
      return this._cachedData.delete(serviceUrl);
    }
    return null;
  }

  public deleteAllCache() {
    this._cachedData = new Map<string, CacheEntry>();
  }

  getHttpRequestHeaders(
    serviceUri: string,
    maxAge: number,
    resetCache = false
  ): HttpHeaders {
    let headers = new HttpHeaders();
    const serviceUrl = this.getServiceUrlWithoutCacheParam(serviceUri);
    if (this.isAddedToCache(serviceUri)) {
      const cacheEntry = this.getCacheEntry(serviceUrl);
      if (!!cacheEntry && cacheEntry.lastRead) {
        const isExpired = cacheEntry.lastRead + maxAge < Date.now();
        if (isExpired || resetCache) {
          headers = headers.set('reset-cache', 'true');
        }
      }
    }
    return headers;
  }

  private getServiceUrlWithoutCacheParam(serviceUri: string): string {
    return serviceUri
      .replace('&clearCache=false', '')
      .replace('&clearCache=true', '')
      .replace('clearCache=false', '')
      .replace('clearCache=true', '');
  }
}
